export default "__VITE_ASSET__69b3cc0d__"